import {VGLawCookie} from "vglawcookie";

$(document).ready(function () {
	$('.testimonial-content .show-full').click(function () {
		let $cont = $(this).closest('.testimonial-content');
		$cont.find('.short').hide();
		$cont.find('.full').show();
		$(this).hide();

		return false;
	});

	$(document).on('change', '.trigger-form', function () {
		let formId = $(this).attr('form');
		$('#'+formId).submit();
	});

	new VGLawCookie({
		enableLinkMore: true,
	});
});